<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #UPLOADED="{ params }">
      <Row v-if="params.img && params.img.length" type="flex" justify="start">
        <Col
          v-for="item in params.img"
          :key="item.id"
          span="4"
          class="demo-upload-list"
          style="padding: 0; margin: 0; font-size: 0; margin-right: 10px"
        >
          <img style="width: 100%" :src="item.src" />
          <div class="demo-upload-list-cover" style="padding: 0; margin: 0">
            <Icon type="ios-eye-outline" @click.native="openImg(item.src)">
            </Icon>
            <Icon
              v-if="!params.is_delete"
              type="ios-trash-outline"
              @click.native="delUploadFile(item.id, params)"
            >
            </Icon>
          </div>
        </Col>
      </Row>
      <template v-if="params.doc && params.doc.length">
        <div
          @click="openFile(item.src)"
          v-for="item in params.doc"
          :key="item.id"
          class="div-hover"
        >
          <span> {{ item.name }}</span>
          <Icon
            v-if="!params.is_delete"
            @click.stop="delUploadFile(item.id, params)"
            class="icon-close"
            size="20"
            type="ios-close"
          />
        </div>
      </template>
    </template>
  </cTable>
</template>

<script>
import {
  assistPlatform,
  addAssistPlatform,
  updateAssistPlatform,
  assistPlatformFinish,
  deleteAssistPlatformFile,
} from "@/api/finance/assistPlatform";
import { getUserDepart, getUserList } from "@/api/public";
import cTable from "@/base/common/index";
import { getSelectType, getKeysType } from "@/api/public";
import { mapState } from "vuex";
import { copyToClipboard } from "@/utils/copyClick";
export default {
  name: "assistPlatform",
  components: {
    cTable,
  },
  async mounted() {
    this.selData.userList = (await getUserList()).data.payload;
    this.selData.userDepart = (await getUserDepart()).data.payload;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "staff_id") item.options = this.selData.userList;
    });
    this.modals.add.fields.forEach(async (item) => {
      if (item.key === "department") item.options = this.selData.userDepart;
      if (item.key === "staff_id") item.options = this.selData.userList;
    });
    this.modals.detail.fields.forEach(async (item) => {
      if (item.key === "department") item.options = this.selData.userDepart;
      if (item.key === "staff_id") item.options = this.selData.userList;
    });
  },
  computed: {
    ...mapState({
      remindId: (state) => state.app.remindId,
    }),
  },
  watch: {
    remindId(newVal) {
      if (newVal) {
        this.$refs["table"].$refs["header"].searchForm["keywords"] = newVal;
        this.$refs["table"].getList();
        this.$store.commit("remindIdFun", 0);
      }
    },
  },
  data() {
    return {
      selData: {
        userList: [],
        userDepart: [],
      },
      methods: {
        list: (p) => {
          p["type"] = "feedback";
          return assistPlatform(p);
        },
        detail: (p) => {
          p["type"] = "detail";
          return assistPlatform(p);
        },
        addAssistPlatform,
        updateAssistPlatform,
        finish: assistPlatformFinish,
        deleteAssistPlatformFile,
      },
      modals: {
        add: {
          slots: ["UPLOADED"],
          methods: {
            ok({ row, close }) {
              let isFun = row.id ? "updateAssistPlatform" : "addAssistPlatform";
              row["type"] = "feedback";
              let data = new FormData();
              for (const key in row) {
                if (key === "files" && row[key]) {
                  for (var i = 0; i < row[key].length; i++) {
                    data.append("files[]", row[key][i]); // 文件对象
                  }
                } else if (key === "staff_id" && row[key]) {
                  for (var i = 0; i < row[key].length; i++) {
                    data.append("staff_id[]", row[key][i]); // 文件对象
                  }
                } else {
                  if (row[key]) {
                    data.append(key, row[key]);
                  }
                }
              }
              this.$page
                .handleRequestMethods(
                  isFun,
                  row.id ? { data, id: row.id } : data,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 110,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              // department: [
              //   {
              //     required: true,
              //     message: "department cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // staff_id: [
              //   {
              //     required: true,
              //     type: "array",
              //     message: "staff cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              title: [
                {
                  required: true,
                  message: "title be empty",
                  trigger: "blur",
                },
              ],
              cause: [
                {
                  required: true,
                  message: "cause be empty",
                  trigger: "blur",
                },
              ],
              content: [
                {
                  required: true,
                  message: "content cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { title: 24 },
            { cause: 24 },
            { department: 24 },
            { staff_id: 24 },
            { content: 24 },
            { airway_number: 24 },
            { files: 24 },
            { uploaded: 24 },
          ],
          fields: [
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx,.pdf,.jpg,.png,.jpeg,.gif",
              },
              methods: {
                beforeUpload({ file, row }) {
                  if (row["files"]) row["files"].push(file);
                  else row["files"] = [file];
                  return false;
                },
              },
            },
            {
              name: () => this.$t("zhTitle"),
              key: "title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("zhTitle"),
            },
            {
              name: () => this.$t("assistDepartment"),
              key: "department",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("assistDepartment"),
              options: [],
              bind: {
                multiple: true,
              },
              show: ({ row }) => (row.id ? false : true),
              methods: {
                "on-change"({ fields, value, row }) {
                  fields.forEach(async (item) => {
                    if (item.key === "staff_id") {
                      getUserList({ department: value }).then((res) => {
                        item.options = res.data.payload;
                      });
                      row.staff_id = [];
                      this.$forceUpdate();
                    }
                  });
                },
              },
            },
            {
              name: () => this.$t("needAssistPerson"),
              key: "staff_id",
              component: "Select",
              bind: {
                multiple: true,
              },
              show: ({ row }) => (row.id ? false : true),
              placeholder: () =>
                this.$t("select") + this.$t("needAssistPerson"),
              options: [],
            },
            {
              name: () => this.$t("ReasonFeedback"),
              key: "cause",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("ReasonFeedback"),
            },
            {
              name: () => this.$t("need") + this.$t("AssistContent"),
              key: "content",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4,
              },
              placeholder: () =>
                this.$t("enter") + this.$t("need") + this.$t("AssistContent"),
            },
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2,
              },
              placeholder: () => this.$t("enter") + this.$t("orderNum"),
            },
            {
              name: () => this.$t("uploaded"),
              key: "uploaded",
              solt: "UPLOADED",
              show: ({ row }) => {
                return row.id && (row.img.length || row.doc.length)
                  ? true
                  : false;
              },
            },
          ],
        },
        detail: {
          slots: ["UPLOADED"],
          methods: {
            ok({ row, close }) {
              let newData = {
                type: "detail",
                feedback_number: row.feedback_number,
                staff_id: row.staff_id,
                content: row.content,
                airway_number: row.airway_number,
                feedback_id: row.id,
                files: row.files,
              };
              let data = new FormData();
              for (const key in newData) {
                if (key === "files" && newData[key]) {
                  for (var i = 0; i < newData[key].length; i++) {
                    data.append("files[]", newData[key][i]); // 文件对象
                  }
                } else if (key === "staff_id" && newData[key]) {
                  for (var i = 0; i < newData[key].length; i++) {
                    data.append("staff_id[]", newData[key][i]); // 文件对象
                  }
                } else {
                  if (newData[key]) {
                    data.append(key, newData[key]);
                  }
                }
              }
              let obj = {
                method: "get",
                feedback_id: row.id,
              };
              this.$page
                .handleRequestMethods("addAssistPlatform", data, true)
                .then(() => {
                  this.getList(obj);
                  this.$store.commit("remindFun", true);
                  this.$refs["form"].clear();
                  let setT = setTimeout(() => {
                    this.disabledConfirm = true;
                    clearTimeout(setT);
                  }, 0);
                  // close();
                });
            },
          },
          footer: {
            ok: {
              name: this.$t("order_submit"),
            },
          },
          config: {
            listFn: "detail",
            title: "detail",
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;",
            },
            modalBind: {
              width: "80%",
              styles: {
                top: "30px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              content: [
                {
                  required: true,
                  message: "content cannot be empty",
                  trigger: "blur",
                },
              ],
              // staff_id: [
              //   {
              //     required: false,
              //     type: "array",
              //     message: "staff cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
            },
          },
          grid: [
            {
              name: () => this.$t("feedbackArea"),
              span: 10,
              children: [
                {
                  cause: 24,
                },
                {
                  message: 24,
                },
                {
                  airway_number: 24,
                },
                {
                  uploaded: 24,
                },
              ],
            },
            {
              name: () => this.$t("FollowArea"),
              span: 14,
              children: [
                {
                  department: 8,
                  staff_id: 16,
                },
                {
                  content: 24,
                },
                // {
                //   airway_number: 24
                // },
                {
                  files: 24,
                },
              ],
            },
            // { cause: 10, department: 6, staff_id: 8 },
            // { message: 10, content: 14 },
            // { uploaded: 10, files: 14 }
            // { leftNull: 10, files: 14 }
          ],
          fields: [
            {
              name: () => this.$t("assistDepartment"),
              key: "department",
              component: "Select",
              bind: {
                multiple: true,
              },
              placeholder: () =>
                this.$t("select") + this.$t("assistDepartment"),
              options: [],
              methods: {
                "on-change"({ fields, value, row }) {
                  fields.forEach(async (item) => {
                    if (item.key === "staff_id") {
                      getUserList({ department: value }).then((res) => {
                        item.options = res.data.payload;
                      });
                      row.staff_id = [];
                      this.$forceUpdate();
                    }
                  });
                },
              },
            },
            {
              name: () => this.$t("needAssistPerson"),
              key: "staff_id",
              component: "Select",
              bind: {
                multiple: true,
              },
              placeholder: () =>
                this.$t("select") + this.$t("needAssistPerson"),
              options: [],
            },
            {
              name: () => this.$t("ReasonFeedback"),
              key: "cause",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("ReasonFeedback"),
              bind: {
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 },
              },
              disabled: true,
            },
            {
              name: () => this.$t("need") + this.$t("AssistContent"),
              key: "message",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("need") + this.$t("AssistContent"),
              disabled: true,
              bind: {
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 },
              },
            },
            {
              name: () => this.$t("FollowCase"),
              key: "content",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4,
              },
              placeholder: () => this.$t("enter") + this.$t("FollowCase"),
            },
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              disabled: true,
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2,
                col: 18,
              },
              btnList: [
                {
                  type: "primary",
                  name: this.$t("copy") + this.$t("all"),
                  bind: {
                    size: "small",
                  },
                  methods: {
                    click() {
                      copyToClipboard(this.$form.formData.airway_number, this);
                    },
                  },
                },
              ],
              placeholder: () => this.$t("enter") + this.$t("orderNum"),
            },
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx,.pdf,.jpg,.png,.jpeg,.gif",
              },
              methods: {
                beforeUpload({ file, row }) {
                  if (row["files"]) row["files"].push(file);
                  else row["files"] = [file];
                  return false;
                },
              },
            },
            {
              name: () => this.$t("uploaded"),
              key: "uploaded",
              solt: "UPLOADED",
            },
          ],
          table: {
            config: {
              align: "center",
              height: 300,
            },
            footer: {
              show: true,
            },
            fields: [
              {
                name: () => this.$t("FollowPerson"),
                key: "staff",
                align: "left",
                tooltip: true,
                width: 130,
              },
              {
                name: () => this.$t("FollowTime"),
                key: "create_time",
                align: "left",
                tooltip: true,
                width: 150,
              },
              {
                name: () => this.$t("FollowCase"),
                key: "message",
                align: "left",
                tooltip: true,
              },
              // {
              //   name: () => this.$t("Appendix"),
              //   align: "center",
              //   tooltip: true,
              //   width: 150,
              //   component: "Button",
              //   bind: {
              //     type: "primary",
              //     size: "small"
              //   },
              //   disabled: ({ row }) => {
              //     return (
              //       row.img && !row.img.length && row.doc && !row.doc.length
              //     );
              //   },
              //   methods: {
              //     render({ row }) {
              //       return "查看";
              //     },
              //     click({ row }) {
              //       this.$page.getModal("appendix").open(row);
              //     }
              //   }
              // },
              // {
              //   name: () => this.$t("FollowTime"),
              //   key: "create_time",
              //   align: "center",
              //   tooltip: true,
              //   width: 150
              // },
              // {
              //   name: () => this.$t("FollowPerson"),
              //   key: "staff",
              //   align: "center",
              //   tooltip: true,
              //   width: 130
              // },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 150,
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("Appendix"),
                    type: "appendix",
                    fnName: "appendix",
                    bind: {
                      type: "primary",
                    },
                    disabled: ({ row }) => {
                      return (
                        row.img && !row.img.length && row.doc && !row.doc.length
                      );
                    },
                  },
                  {
                    name: () => this.$t("withdraw"),
                    type: "delete",
                    fnName: "delete",
                    show: ({ row }) => {
                      return row.is_del === 1;
                    },
                    bind: {
                      type: "error",
                    },
                  },
                ],
                methods: {
                  appendix({ row }) {
                    this.getModal("appendix").open(row);
                  },
                  // update({ row }) {
                  //   row["method"] = "get";
                  //   let obj = {
                  //     method: "get",
                  //     id: row.id
                  //   };
                  //   this.handleRequestMethods("list", obj).then(res => {
                  //     this.getModal("add").setTitle(this.$t("update"));
                  //     let data = res.payload;
                  //     data["method"] = "put";
                  //     this.getModal("add").open(data);
                  //   });
                  // },
                  delete({ row }) {
                    this.$Modal.confirm({
                      title:
                        this.$t("whether") +
                        this.$t("confirm") +
                        this.$t("delete") +
                        this.$t("createTime") +
                        "：" +
                        row.create_time +
                        this.$t("assistOrder") +
                        "?",
                      onOk: () => {
                        this.handleRequestMethods(
                          "detail",
                          {
                            id: row.id,
                            method: "delete",
                            feedback_id: row.feedback_id,
                          },
                          true
                        ).then((res) => {
                          // this.$Message.success(res.data.msg);
                          let obj = {
                            method: "get",
                            feedback_id: row.feedback_id,
                          };
                          this.getModal("detail").getList(obj);
                        });
                      },
                    });
                  },
                },
              },
            ],
          },
        },
        appendix: {
          slots: ["UPLOADED"],
          config: {
            title: this.$t("Appendix"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 110,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          grid: [{ img: 24 }],
          fields: [
            {
              name: () => this.$t("uploaded"),
              key: "img",
              solt: "UPLOADED",
            },
          ],
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            },
          },
          {
            key: "status",
            component: "Select",
            options: [],
            bind: {
              style: {
                width: "150px",
              },
            },
            // clearable: false,
            placeholder() {
              return this.$t("select") + this.$t("ProcessingProgress");
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType("ASSIST_SELECT_TYPE")).data
                  .payload["ASSIST_SELECT_TYPE"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "about_me",
            component: "Select",
            options: [{ value: "YES", label: "YES" }],
            bind: {
              style: {
                width: "150px",
              },
            },
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            // clearable: false,
            placeholder() {
              return this.$t("whether") + this.$t("relatedMe");
            },
          },
          {
            key: "staff_type",
            component: "Select",
            options: [],
            bind: {
              style: {
                width: "100px",
              },
            },
            clearable: false,
            // placeholder() {
            //   return this.$t("select") + this.$t("operate") + this.$t("type");
            // },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType("ASSIST_CLIENT_TYPE")).data
                  .payload["ASSIST_CLIENT_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            name: () => this.$t("operate"),
            key: "staff_id",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("operate"),
            options: [],
          },
          {
            key: "keywordsType",
            component: "Select",
            options: [],
            bind: {
              style: {
                width: "150px",
              },
            },
            // clearable: false,
            placeholder() {
              return this.$t("keyword") + this.$t("type");
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("GOOGLE_SITES_KEYWORDS")).data
                  .payload;
                field.options = res;
                // searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
            default: this.$route.params.id ? this.$route.params.id : "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open({ method: "post" });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("feedbackNum"),
          key: "feedback_number",
          component: "Button",
          copy: true,
          width: 180,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              let data = {
                method: "get",
                feedback_id: row.id,
              };
              let obj = {
                id: row.id,
                cause: row.cause,
                airway_number: row.airway_number
                  ? row.airway_number
                  : this.$t("Not") + this.$t("orderNum"),
                message: row.message,
                img: row.img,
                doc: row.doc,
                files: "",
                content: "",
                is_delete: true,
              };
              this.$page.getModal("detail").open(obj, function () {
                this.fields.forEach((el) => {
                  if (el.disabled) {
                    el.default = obj[el.key];
                  }
                  if (
                    el.key == "uploaded" &&
                    obj.img &&
                    !obj.img.length &&
                    obj.doc &&
                    !obj.doc.length
                  ) {
                    el.name = () => "";
                  }
                });
                this.pageConfig.data = data;
                this.getList();
                this.title = row.title ? row.title : this.$t("zhTitle");
              });
            },
          },
        },
        {
          name: () => this.$t("zhTitle"),
          key: "title",
          showOverflow: false,
          minWidth: 120,
          align: "left",
        },
        {
          name: () => this.$t("ReasonFeedback"),
          key: "cause",
          showOverflow: false,
          minWidth: 200,
          align: "left",
        },
        {
          name: () => this.$t("need") + this.$t("AssistContent"),
          key: "message",
          showOverflow: false,
          minWidth: 200,
          align: "left",
        },
        {
          name: () => this.$t("newest") + this.$t("FollowCase"),
          key: "new_detail",
          minWidth: 200,
          showOverflow: false,
          align: "left",
          component: "a",
          methods: {
            render({ value }) {
              return value ? value : this.$t("immediately") + this.$t("follow");
            },
            click({ row }) {
              let data = {
                method: "get",
                feedback_id: row.id,
              };
              let obj = {
                id: row.id,
                cause: row.cause,
                airway_number: row.airway_number,
                message: row.message,
                img: row.img,
                doc: row.doc,
                files: "",
                content: "",
                is_delete: true,
              };
              this.$page.getModal("detail").open(obj, function () {
                this.fields.forEach((el) => {
                  if (el.disabled) {
                    el.default = obj[el.key];
                  }
                  if (
                    el.key == "uploaded" &&
                    !obj.img.length &&
                    !obj.doc.length
                  ) {
                    el.name = () => "";
                  }
                });
                this.pageConfig.data = data;
                this.getList();
                this.title = row.title ? row.title : this.$t("zhTitle");
              });
            },
          },
        },
        {
          name: () => this.$t("newest") + this.$t("FollowPerson"),
          key: "new_user",
          width: 100,
          showOverflow: false,
        },
        {
          name: () => this.$t("newest") + this.$t("FollowTime"),
          key: "new_time",
          width: 150,
        },
        {
          name: () => this.$t("ProcessingProgress"),
          key: "status",
          width: 100,
          render(h, { row }) {
            return h(
              "span",
              { style: { color: row.status == "已完结" ? "#2d8cf0" : "#f90" } },
              row.status
            );
          },
        },
        {
          name: () => this.$t("startingTime"),
          key: "create_time",
          width: 150,
        },
        {
          name: () => this.$t("FeedbackPerson"),
          key: "staff",
          width: 100,
        },
        {
          name: () => this.$t("finishTime"),
          key: "finish_time",
          width: 150,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 130,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
              show({ row }) {
                return row.finish_time ? false : true;
              },
            },
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            //   bind: {
            //     type: "error"
            //   }
            // },
            {
              name: this.$t("finish"),
              type: "finish",
              fnName: "finish",
              bind: {
                type: "success",
              },
              show({ row }) {
                return row.finish_time ? false : true;
              },
            },
          ],
          methods: {
            update({ row }) {
              row["method"] = "get";
              let obj = {
                method: "get",
                id: row.id,
              };
              this.handleRequestMethods("list", obj).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                let data = res.payload;
                data["method"] = "put";
                data["files"] = "";
                this.getModal("add").open(data);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("feedbackNum") +
                  "：" +
                  row.feedback_number +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "list",
                    {
                      id: row.id,
                      method: "delete",
                    },
                    true
                  ).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
            finish({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("finish") +
                  this.$t("orderNum") +
                  "：" +
                  row.feedback_number +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("finish", row.id, true).then(
                    (res) => {
                      // this.$Message.success(res.data.msg);
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
  methods: {
    openFile(url) {
      let src = ''; //"https://view.officeapps.live.com/op/view.aspx?src=";
      if (
        ["pdf"].indexOf(url.substring(url.lastIndexOf(".") + 1).toLowerCase()) >
        -1
      ) {
        window.open(this.$globalUrl + url);
      } else {
        window.open(src + this.$globalUrl + url, "_blank");
      }
    },
    openImg(url) {
      window.open(this.$globalUrl + url);
    },
    delUploadFile(id, row) {
      this.$Modal.confirm({
        title:
          this.$t("whether") + this.$t("confirm") + this.$t("delete") + "?",
        onOk: () => {
          this.$refs["table"]
            .handleRequestMethods("deleteAssistPlatformFile", id, true)
            .then((res) => {
              row.img.forEach((el, index) => {
                if (el.id == id) {
                  row.img.splice(index, 1);
                }
              });
              row.doc.forEach((el, index) => {
                if (el.id == id) {
                  row.doc.splice(index, 1);
                }
              });
              if (!row.feedback_number) {
                let obj = {
                  method: "get",
                  feedback_id: row.feedback_id,
                };
                this.$refs["table"].getModal("detail").getList(obj);
                if (!row.img.length && !row.doc.length) {
                  this.$refs["table"].getModal("appendix").close();
                }
              } else {
                if (!row.img.length && !row.doc.length) {
                  this.$refs["table"].getModal("add").fields.forEach((el) => {
                    if (el.key == "uploaded") {
                      el.show = () => false;
                    }
                  });
                }
                this.$refs["table"].getModal("add").close();
                this.$refs["table"].getModal("add").open(row);
              }
            });
        },
      });
    },
  },
};
</script>
